import React from "react";

export default function TenantTable({
    tenants,
    documents,
    selectedFiles,
    onEdit,
    onDelete,
    onFileChange,
    onUpload,
    onDeleteDoc,
}) {
    if (!tenants.length) return <p>No tenants found.</p>;

    return (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Documents</th>
                    <th>Actions</th>
                </tr>
            </thead>

            <tbody>
                {tenants.map((tenant) => (
                    <tr key={tenant.id}>
                        <td>{tenant.name}</td>
                        <td>{tenant.email}</td>

                        {/* Documents */}
                        <td>
                            {(documents[tenant.id] || []).map((doc) => (
                                <div key={doc.id}>
                                    <a
                                        href={`${process.env.REACT_APP_UPLOAD_URL || "http://localhost:5000"}${doc.url}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {doc.name}
                                    </a>

                                    <button onClick={() => onDeleteDoc(doc.id, tenant.id)}>
                                        Delete
                                    </button>
                                </div>
                            ))}

                            <input
                                type="file"
                                accept="application/pdf"
                                onChange={(e) =>
                                    onFileChange(tenant.id, e.target.files[0])
                                }
                            />

                            <button onClick={() => onUpload(tenant.id)}>
                                Upload PDF
                            </button>
                        </td>

                        {/* Actions */}
                        <td>
                            <button onClick={() => onEdit(tenant)}>Edit</button>

                            <button
                                onClick={() => {
                                    if (window.confirm("Delete tenant?")) {
                                        onDelete(tenant.id);
                                    }
                                }}
                            >
                                Delete
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}